// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VXKm_","prefix":"styles_prefix__37pNL","postfix":"styles_postfix__47ZqP"};